<template>
  <div class="slide-banner">
    <div class="banner-container" @mouseenter="pauseAutoPlay" @mouseleave="resumeAutoPlay">
      <!-- Previous slide (blurred) -->
      <div v-if="banners.length > 1 && getPrevSlide()" class="slide slide-prev"
        :class="{ 'visible': banners.length > 1 }" :style="{ backgroundImage: `url(${getPrevSlide().image_url})` }">

      </div>

      <!-- Current slide -->
      <div v-if="banners.length && banners[currentIndex]" class="slide slide-current"
        :style="{ backgroundImage: `url(${banners[currentIndex].image_url})` }">

      </div>

      <!-- Next slide (blurred) -->
      <div v-if="banners.length > 1 && getNextSlide()" class="slide slide-next"
        :class="{ 'visible': banners.length > 1 }" :style="{ backgroundImage: `url(${getNextSlide().image_url})` }">

      </div>

      <!-- Navigation buttons -->
      <button class="nav-button nav-prev" @click="prevSlide" :disabled="banners.length <= 1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="15,18 9,12 15,6"></polyline>
        </svg>
      </button>

      <button class="nav-button nav-next" @click="nextSlide" :disabled="banners.length <= 1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="9,18 15,12 9,6"></polyline>
        </svg>
      </button>

      <!-- Dots indicator -->
      <!-- <div class="dots-container">
        <button 
          v-for="(slide, index) in slides" 
          :key="index"
          class="dot"
          :class="{ 'active': index === currentIndex }"
          @click="goToSlide(index)"
        ></button>
      </div> -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  props: ["banners"],
  data() {
    return {
      currentIndex: 0,
      autoPlayInterval: null,
      isAutoPlaying: true,
      autoPlayDelay: 4000, // 4 วินาที
      isPaused: false,

    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.banners?.length
    },
    prevSlide() {
      this.currentIndex = this.currentIndex === 0 ? this.banners?.length - 1 : this.currentIndex - 1
    },
    goToSlide(index) {
      this.currentIndex = index
      this.resetAutoPlay()
    },
    getPrevSlide() {
      const prevIndex = this.currentIndex === 0 ? this.banners?.length - 1 : this.currentIndex - 1
      return this.banners[prevIndex]
    },
    getNextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.banners?.length
      return this.banners[nextIndex]
    },
    startAutoPlay() {
      if (this.isAutoPlaying && !this.isPaused) {
        this.autoPlayInterval = setInterval(() => {
          this.nextSlide()
        }, this.autoPlayDelay)
      }
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval)
        this.autoPlayInterval = null
      }
    },
    resetAutoPlay() {
      this.stopAutoPlay()
      this.startAutoPlay()
    },
    pauseAutoPlay() {
      this.isPaused = true
      this.stopAutoPlay()
    },
    resumeAutoPlay() {
      this.isPaused = false
      this.startAutoPlay()
    },
    toggleAutoPlay() {
      this.isAutoPlaying = !this.isAutoPlaying
      if (this.isAutoPlaying) {
        this.resumeAutoPlay()
      } else {
        this.stopAutoPlay()
      }
    }
  }
}
</script>

<style scoped>
.slide-banner {
  width: 100%;
  margin: 0 auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.banner-container {
  position: relative;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 16px;
}

.slide {
  position: absolute;
  height: 85%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 16px;
}

.slide-current {
  
  width: 1008px;
  z-index: 3;
  transform: scale(1);
  filter: blur(0px);
}

.slide-prev,
.slide-next {
  width: 50%;
  z-index: 1;
  transform: scale(0.8);
  filter: blur(3px);
  opacity: 0;
  transition: all 0.5s ease;
}

.slide-prev.visible,
.slide-next.visible {
  opacity: 0.6;
}

.slide-prev {
  left: -15%;
}

.slide-next {
  right: -15%;
}

.slide-content {
  text-align: center;
  color: white;
  padding: 2rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  max-width: 500px;
}

.slide-current .slide-content h2 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

.slide-prev .slide-content h3,
.slide-next .slide-content h3 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

.slide-content p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.cta-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 4;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.nav-button:hover {
  background: white;
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.nav-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nav-button:disabled:hover {
  transform: translateY(-50%) scale(1);
}

.nav-prev {
  left: 20px;
}

.nav-next {
  right: 20px;
}

.dots-container {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 4;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid white;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background: white;
  transform: scale(1.2);
}

.dot:hover {
  transform: scale(1.1);
}

/* Auto Play Controls */
.auto-play-controls {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 4;
}

.control-button {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.control-button:hover {
  background: white;
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.progress-bar {
  width: 60px;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 2px;
  animation: progress 4s linear infinite;
  transform-origin: left;
}

.progress-fill.paused {
  animation-play-state: paused;
}

@keyframes progress {
  0% {
    transform: scaleX(0);
  }

  100% {
    transform: scaleX(1);
  }
}

/* เพิ่ม hover effect สำหรับ banner */
.banner-container:hover .slide-prev.visible,
.banner-container:hover .slide-next.visible {
  opacity: 0.8;
  transform: scale(0.85);
}

.banner-container:hover .slide-current {
  transform: scale(1.02);
}

@media (max-width: 978px) {
    
  .slide-current { 
    width: 80%;  
    background-position: left;
  }
 
}

/* Responsive Design */
@media (max-width: 768px) {
  .banner-container {
    height: 300px;
  }

  .slide-current {
    width: 95%;
    height: 90%; 
    object-fit: fill;
  }

  .slide-prev,
  .slide-next {
    display: none;
  }

  /* .slide-current .slide-content h2 {
    font-size: 1.8rem;
  } */

  .slide-content p {
    font-size: 1rem;
  }

  .nav-button {
    width: 40px;
    height: 40px;
  }

  .nav-prev {
    left: 10px;
  }

  .nav-next {
    right: 10px;
  }

  .auto-play-controls {
    top: 10px;
    right: 10px;
    gap: 8px;
  }

  .control-button {
    width: 32px;
    height: 32px;
  }

  .progress-bar {
    width: 40px;
    height: 3px;
  }
}

@media (max-width: 480px) {
  .banner-container {
    height: 250px;
  }

  .slide-content {
    padding: 1rem;
  }

  .slide-current .slide-content h2 {
    font-size: 1.5rem;
  }

  .slide-content p {
    font-size: 0.9rem;
  }

  .cta-button {
    padding: 10px 20px;
    font-size: 0.9rem;
  }

  .auto-play-controls {
    display: none;
    /* ซ่อนบนหน้าจอเล็กมาก */
  }
}
</style>
